/** OskJoinInvitationStatus of the API (sent as a number). */
export enum OskJoinInvitationStatus {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
  Cancelled = 3,
  Expired = 4,
}

export const OSK_JOIN_INVITATION_STATUS_LABELS: Record<OskJoinInvitationStatus, string> = {
  [OskJoinInvitationStatus.Pending]: 'Czeka na akceptację',
  [OskJoinInvitationStatus.Accepted]: 'Przyjęte',
  [OskJoinInvitationStatus.Rejected]: 'Odrzucone',
  [OskJoinInvitationStatus.Cancelled]: 'Wycofane',
  [OskJoinInvitationStatus.Expired]: 'Wygasło',
};
